import { isServer } from "@decibeltrade/web-core/utils";

import { StorageValue } from "./types";

export const setSessionStorageItem = (key: string, value: StorageValue) => {
  if (isServer()) return;
  if (typeof value === "undefined" || value === null) {
    removeSessionStorageItem(key);
    return;
  }
  const stringifiedValue = JSON.stringify(value);
  window.sessionStorage.setItem(key, stringifiedValue);
};

export const removeSessionStorageItem = (key: string) => {
  if (isServer()) return;
  window.sessionStorage.removeItem(key);
};

export const getSessionStorageItem = (key: string) => {
  if (isServer()) return null;
  return window.sessionStorage.getItem(key);
};
